<script lang="ts">
	interface Props {
		row: Record<string, string>
	}

	let { row }: Props = $props()

	const avatars = $derived(
		row.avatars ??
			Array.from(
				{ length: 6 },
				(_) =>
					'https://images.unsplash.com/photo-1738526787238-96d5352c2ba9?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
			)
	)
</script>

<div class="flex -space-x-2">
	{#each avatars.slice(0, 5) as avatar, i}
		<img
			src={avatar}
			alt={`User ${i + 1}`}
			class="w-8 h-8 rounded-full border-2 border-white relative z-10"
		/>
	{/each}
	{#if avatars.length > 5}
		<div
			class="w-8 h-8 flex items-center justify-center rounded-full relative z-20
bg-[#f8f9fb] border border-[rgba(0,58,102,0.10)]
outline outline-2 outline-white"
		>
			<span class="text-[rgba(0,29,51,0.70)] text-center font-inter text-sm font-semibold leading-5"
				>99+</span
			>
		</div>
	{/if}
</div>
